import React from 'react';

import { useState, useEffect } from 'react';

import axios from 'axios';


import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import LoadingButton from 'components/Shared/LoadingButton';

import localStorageHelper from 'utils/localStorageHelper';



export default function AcknowledgeDemandeVirement({ actionId, reloadHistory }) {

    const [allowed, setAllowed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [comment, setComment] = useState('');
    const [done, setDone] = useState(null);

    useEffect(() => {

        setAllowed(localStorageHelper.getUtilisateurComptable());

    }, []);


    useEffect(() => {

        const post = () => {

            var param = {
                effectue: done,
                commentaire: comment
            };

            axios.post(`api/reclamationActions/${actionId}/acquitter-demande-virement`, param)
                .then(function (response) {

                    console.log(response);

                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    // always executed
                    setLoading(false);
                    setComment('');
                    setDone(null);
                    reloadHistory();
                });
        };


        if (loading) {
            post();
        }

    }, [actionId, loading, done, comment]);


    const handleAnnulation = () => {
        setDone(false);
        setLoading(true);
    }

    const handleConfirmation = () => {
        setDone(true);
        setLoading(true);
    }
    

    return (
        <>

        { !allowed && (<span>Vous n'êtes pas autorisé à acquitter le virement.</span>) }

        {allowed && (
            <Card>

                <CardHeader title="Virement" />
                <CardContent>
                    <TextField
                        label="Commentaire"
                        multiline
                        fullWidth
                        value={comment}
                        onChange={e => setComment(e.target.value)}
                        disabled={loading || !allowed}
                    />
                </CardContent>
                <CardActions sx={{ justifyContent: 'right' }}>
                    <LoadingButton
                        color="primary"
                        onClick={handleAnnulation}
                        label="annulé"
                        pending={loading}
                        disabled={!allowed}
                    />
                    <LoadingButton
                        color="secondary"
                        onClick={handleConfirmation}
                        label="effectué"
                        pending={loading}
                        disabled={!allowed}
                    />
                </CardActions>




            </Card>)}


        </>
    );

}


